/* Elysian Subscriptions, round 2 (2026-09-28). Loaded by sections/elysian-plans.liquid only. The module image follows the coffee choice:
   the bag for the checked coffee gets data-on (fades in over the one before, which holds as data-prev until the next pick). Works for
   mouse, touch and keyboard (the radios' change event). Without JS the default coffee's bag shows (data-on from Liquid). */
(function () {
  /* round 4: the Ships free badge follows the coffee's price for each tile (flags rendered by Liquid, one per coffee) */
  function bindShip(sub) {
    if (sub.hasAttribute('data-ely-ship-bound') || !sub.querySelector('[data-ely-sub-ship]')) return;
    sub.setAttribute('data-ely-ship-bound', '');
    var apply = function () {
      var c = sub.querySelector('[data-ely-sub-coffee]:checked');
      var i = c ? (parseInt(c.value, 10) || 1) - 1 : 0;
      Array.prototype.forEach.call(sub.querySelectorAll('[data-ely-sub-ship]'), function (el) {
        el.hidden = (el.getAttribute('data-ely-sub-ship').split('|')[i] || '0') !== '1';
      });
    };
    Array.prototype.forEach.call(sub.querySelectorAll('[data-ely-sub-coffee]'), function (r) { r.addEventListener('change', apply); });
    apply();
  }
  /* round 5: a size pick on a tile that carries the Ships free star wiggles the star once (never on load; none with reduced motion;
     same keyframes and timing as the product page's star) */
  function bindWiggle(sub) {
    if (sub.hasAttribute('data-ely-wiggle-bound')) return;
    sub.setAttribute('data-ely-wiggle-bound', '');
    Array.prototype.forEach.call(sub.querySelectorAll('[data-ely-sub-size]'), function (r) {
      r.addEventListener('change', function () {
        if (!r.checked || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
        var star = r.closest('.ely-size-tile').querySelector('.ely-sub-ship');
        if (!star || star.hidden) return;
        star.classList.remove('is-wiggle'); void star.offsetWidth; star.classList.add('is-wiggle');
      });
    });
    sub.addEventListener('animationend', function (e) { if (e.animationName === 'ely-sub-ship-wiggle') e.target.classList.remove('is-wiggle'); });
  }
  function bind(sub) {
    bindShip(sub);
    bindWiggle(sub);
    var box = sub.querySelector('[data-ely-sub-bags]');
    if (!box || sub.hasAttribute('data-ely-bags-bound')) return;
    sub.setAttribute('data-ely-bags-bound', '');
    var imgs = Array.prototype.slice.call(box.querySelectorAll('.ely-sub__bag'));
    if (imgs.length < 2) return;
    var show = function () {
      var c = sub.querySelector('[data-ely-sub-coffee]:checked');
      var next = box.querySelector('.ely-sub__bag[data-n="' + (c ? c.value : '1') + '"]');
      if (!next || next.hasAttribute('data-on')) return;
      var cur = box.querySelector('.ely-sub__bag[data-on]');
      imgs.forEach(function (i) { i.removeAttribute('data-prev'); });
      if (cur) { cur.removeAttribute('data-on'); cur.setAttribute('data-prev', ''); }
      next.setAttribute('data-on', '');
    };
    Array.prototype.forEach.call(sub.querySelectorAll('[data-ely-sub-coffee]'), function (r) { r.addEventListener('change', show); });
    show();
  }
  function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-ely-sub]'), bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
